import { useMutation } from '@tanstack/react-query';
import { del } from '@truefit/http-utils';
import getCurrentUser from './getCurrentUser';

const useDeleteProfilePicture = () => {
  const getCurrentUserQuery = getCurrentUser();
  return useMutation({
    mutationFn: async () => {
      const response = await del<{ deleted: boolean }>('/v1.0/user/profile-picture');
      return response.data;
    },
    onSuccess: () => {
      getCurrentUserQuery.refetch();
    },
  });
};

export default useDeleteProfilePicture;
